export default __webpack_public_path__ + "static/media/Quicksand-Regular.cffc2790.ttf";